import {
  getActiveCacheOrganizationId,
  readOrgScopedJson,
  writeOrgScopedJson,
} from "./orgCacheStorage";
import { orgScopedUpdateByPk } from "./orgQueryScope";

export const PROJECT_CACHE_KEY = "CP_PROJECTS";

export function getArchiveUpdatePayload() {
  return { status: "archived", is_active: false };
}

export function getRestoreUpdatePayload() {
  return { status: "active", is_active: true };
}

export function isProjectArchived(project) {
  return project?.status === "archived" || project?.is_active === false;
}

export function getActiveProjects(projects = []) {
  return projects.filter((project) => !isProjectArchived(project));
}

export function getCachedProjects(organizationId = null) {
  try {
    const orgId = organizationId ?? getActiveCacheOrganizationId();
    const parsed = readOrgScopedJson(PROJECT_CACHE_KEY, orgId);
    return Array.isArray(parsed) ? parsed : null;
  } catch (error) {
    console.error("PROJECT CACHE READ ERROR:", error);
    return null;
  }
}

export function saveCachedProjects(projects, organizationId = null) {
  const orgId = organizationId ?? getActiveCacheOrganizationId();
  writeOrgScopedJson(PROJECT_CACHE_KEY, orgId, projects || []);
}

export function getCachedActiveProjects(organizationId = null) {
  return getActiveProjects(getCachedProjects(organizationId) || []);
}

/**
 * RG-03 — soft-archive a project within the actor's organization only.
 * @param {object} actor - required for organization scoping
 */
export async function archiveProject(supabaseClient, projectId, actor) {
  return orgScopedUpdateByPk(
    supabaseClient,
    "projects",
    getArchiveUpdatePayload(),
    actor,
    { pkColumn: "project_id", pkValue: projectId },
  );
}

/**
 * RG-03 — restore a project within the actor's organization only.
 * @param {object} actor - required for organization scoping
 */
export async function restoreProject(supabaseClient, projectId, actor) {
  return orgScopedUpdateByPk(
    supabaseClient,
    "projects",
    getRestoreUpdatePayload(),
    actor,
    { pkColumn: "project_id", pkValue: projectId },
  );
}

export function removeProjectFromCache(projectId) {
  try {
    const projects = getCachedProjects();

    if (!projects) {
      return;
    }

    saveCachedProjects(
      projects.filter((project) => project.project_id !== projectId),
    );
  } catch (error) {
    console.error("PROJECT CACHE UPDATE ERROR:", error);
  }
}

export function notifyProjectArchived(projectId) {
  removeProjectFromCache(projectId);

  window.dispatchEvent(
    new CustomEvent("cp-project-archived", {
      detail: { projectId },
    }),
  );
}
